import {
  FETCH_INDUSTRIAL_TYPES,
  FETCH_INDUSTRIAL_TYPES_SUCCESS,
  FETCH_INDUSTRIAL_TYPES_FAILED,
  EDIT_INDUSTRIAL_TYPE
} from "../store/types";

const INITIAL_STATE = {
  industrialtypes:  {
    industrialtypes : [],
    message:null
  },
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const industrialtypesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_INDUSTRIAL_TYPES:
      return {
        ...state,
        loading: true
      };
    case FETCH_INDUSTRIAL_TYPES_SUCCESS:
      return {
        ...state,
        industrialtypes: action.payload,
        loading: false
      };
    case FETCH_INDUSTRIAL_TYPES_FAILED:
      return {
        ...state,
        industrialtypes: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_INDUSTRIAL_TYPE:
      return state;
    default:
      return state;
  }
};